import { Badge, makeStyles, tokens } from '@fluentui/react-components';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SubstitutionMotive } from './SubstitutionWidget.interface';

export interface SubstitutionBadgeProps {
  motive: SubstitutionMotive;
}

interface BadgeConfig {
  labelKey: string;
  defaultLabel: string;
}

const useStyles = makeStyles({
  badge: {
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: 'var(--color-aix-red2)',
    color: tokens.colorNeutralForegroundStaticInverted,
  },
});

const getBadgeConfig = (motive: SubstitutionMotive): BadgeConfig => {
  switch (motive) {
    case 'Cancellation':
    case 'NoLesson':
      return {
        labelKey: 'dashboard:substitution:badge:cancelled',
        defaultLabel: 'Entfällt',
      };
    case 'StandIn':
      return {
        labelKey: 'dashboard:substitution:badge:stand_in',
        defaultLabel: 'Vertretung',
      };
    case 'RoomExchange':
      return {
        labelKey: 'dashboard:substitution:badge:room',
        defaultLabel: 'Raum',
      };
    case 'Exam':
      return {
        labelKey: 'dashboard:substitution:badge:exam',
        defaultLabel: 'Prüfung',
      };
    case 'ShiftedFrom':
    case 'ShiftedTo':
      return {
        labelKey: 'dashboard:substitution:badge:shifted',
        defaultLabel: 'Verschoben',
      };
    case 'Supervision':
      return {
        labelKey: 'dashboard:substitution:badge:supervision',
        defaultLabel: 'Betreuung',
      };
    case 'Release':
      return {
        labelKey: 'dashboard:substitution:badge:release',
        defaultLabel: 'Freisetzung',
      };
    default:
      return {
        labelKey: 'dashboard:substitution:badge:unknown',
        defaultLabel: 'Änderung',
      };
  }
};

export const SubstitutionBadge: FC<SubstitutionBadgeProps> = ({ motive }) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const config = getBadgeConfig(motive);

  return (
    <Badge
      className={styles.badge}
      appearance="filled"
      size="medium"
    >
      {t(config.labelKey, config.defaultLabel)}
    </Badge>
  );
};
